// The launch backfill (src/terminal/digest/launch-score-backfill.json)
// simulates Monitoring before launch: a check on the 1st and the 15th of each
// month in the 3 months up to the launch day, the last day of a month. Each
// Company replays from its latest Assessment at or before the launch day, so
// a rerun moves nothing that a later real Assessment shows.
export const LAUNCH_DAY = "2026-10-31"
const LOOKBACK_MONTHS = 3

const launch = new Date(LAUNCH_DAY)
// Oldest first. Date.UTC carries a negative month into the year before.
export const LAUNCH_CHECK_DAYS = Array.from(
  { length: LOOKBACK_MONTHS },
  (_, index) => launch.getUTCMonth() - LOOKBACK_MONTHS + 1 + index
).flatMap((month) =>
  [1, 15].map((day) =>
    new Date(Date.UTC(launch.getUTCFullYear(), month, day))
      .toISOString()
      .slice(0, 10)
  )
)

// The day monitoring history starts: Reassessments count score changes from
// here, the first simulated check.
export const MONITORING_HISTORY_START = LAUNCH_CHECK_DAYS[0]
